import React from "react";
import styled, { keyframes } from "styled-components";

const TypingIndicator = ({ userIds = [] }) => {
  if (userIds.length === 0) return null;

  return (
    <Container>
      <Bubble>
        <TypingText>
          {userIds.length === 1
            ? "Someone is typing"
            : "Several people are typing"}
        </TypingText>
        <DotsContainer>
          <Dot $delay={0} />
          <Dot $delay={0.2} />
          <Dot $delay={0.4} />
        </DotsContainer>
      </Bubble>
    </Container>
  );
};

export default TypingIndicator;

// Animations
const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
`;

// Styled Components
const Container = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 8px;
  padding: 0 20px;
`;

const Bubble = styled.div`
  background-color: #ffffff;
  border: 1px solid #e1e5e9;
  border-radius: 18px 18px 18px 4px;
  padding: 12px 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 200px;
`;

const TypingText = styled.span`
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
  white-space: nowrap;
`;

const DotsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const Dot = styled.div`
  width: 4px;
  height: 4px;
  background-color: #6c757d;
  border-radius: 50%;
  animation: ${bounce} 1.4s infinite ease-in-out;
  animation-delay: ${(props) => props.$delay}s;
`;
